/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ActiveFilters, FilterField } from "types/filters";

const initialState: {
  filtersFields: FilterField;
  isLoadingFilters: boolean;
  activeFilters: ActiveFilters;
  isFiltersModalOpen: boolean;
  isFiltersDrawerOpen: boolean;
} = {
  filtersFields: {},
  isLoadingFilters: false,
  activeFilters: {},
  isFiltersModalOpen: false,
  isFiltersDrawerOpen: false,
};

const slice = createSlice({
  name: "filtersState",
  initialState,
  reducers: {
    updateFiltersFields: (state, action: PayloadAction<FilterField>) => {
      state.filtersFields = action.payload;
    },
    setIsLoadingFilters: (state, action: PayloadAction<boolean>) => {
      state.isLoadingFilters = action.payload;
    },
    updateActiveFilters: (state, action: PayloadAction<ActiveFilters>) => {
      state.activeFilters = action.payload;
    },
    setIsFiltersModalOpen: (state, action: PayloadAction<boolean>) => {
      state.isFiltersModalOpen = action.payload;
    },
    setIsFiltersDrawerOpen: (state, action: PayloadAction<boolean>) => {
      state.isFiltersDrawerOpen = action.payload;
    },
  },
});

export const filtersSelectorStateActions = slice.actions;

export default slice.reducer;
